const error = {
    view_error: 'Error on loading view.'
}

export default error
